<template>
  <div id="pageFacturacion" class="d-flex align-center mt-4">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <iframe
                :src="this.fields.url"
                width="100%"
                height="100%"
                frameborder="0"
                allowfullscreen>
              </iframe>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import { mapGetters } from 'vuex/dist/vuex.common.js'

export default {
  data: () => ({
    visible: true,
    saving: false,
    saving2: false,
    visibleAsignacionForm: false,
    showNewPasswordConfirm: false, // Estado para mostrar/ocultar la contraseña actual
    showNewPassword: false, // Estado para mostrar/ocultar la nueva contraseña

    // campos del formulario
    user: null,

    fields: {
      url: null
    }
  }),

  methods: {
    async load () {
      try {
        let response = await UserService.getBillingPortal()
        let url = response.data.data.url
        this.fields.url = url
      } catch (error) {
        console.error('Error al cambiar la contraseña:', error)
        this.$toast.error('Ocurrió un error al cambiar la contraseña')
      } finally {
        this.saving2 = false
      }
    }
  },
  computed: {
    ...mapGetters(['CURRENT_USER'])
  },

  created () {
    this.load()
  }
}
</script>
